module.exports = "data:text/vtt;base64,V0VCVlRUDQoNCjENCjAwOjAwOjAwLjAwMCAtLT4gMDA6MDA6MTAuMDAwDQpObyBjYXB0aW9ucyBhdmFpbGFibGUuDQo="